import React, { useEffect } from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import Checked from "../../assets/checked.png"
import CloseIcon from "@mui/icons-material/Close";
import {

 
  IconButton,

} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
export default function VerifiedSuccess() {
    const navigate = useNavigate();
  const { orderId } = useParams();
  const handleClose = () => {
    navigate("/", { replace: true });
   
  };

  useEffect(()=>{
setTimeout(() => {
  navigate(`/vendOrder/vendingprogress/${orderId}`, { replace: true });
}, 3000);
  },[])
  return (
    <Box>
        <Box
          sx={{
            bgcolor: "#FFD54F",
            p: 1.5,
            display: "flex",
            alignItems: "center",
                position: "fixed",
      width: "100%"
          }}
        >
        <IconButton size="small" sx={{ mr: 1 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Match The Number
        </Typography>
      </Box>

    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "#fff",
      }}
    >
      <Card
        sx={{
          border: "1px solid #00BFA5",
          borderRadius: 2,
          width: "80%",
          maxWidth: 300,
          textAlign: "center",
        }}
      >
        <CardContent>
          {/* Verified Badge */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 2,
            }}
          >
            <Box
              component="img"
              src={Checked} // put your uploaded green badge check image here
              alt="Verified"
              sx={{ width: 80, height: 80 }}
            />
          </Box>

          {/* Success Text */}
          <Typography
            variant="h6"
            sx={{ color: "#00BFA5", fontWeight: 600 }}
          >
            Verified Successfully
          </Typography>
        </CardContent>
      </Card>
    </Box>
    </Box>
  );
}
